import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import Header from '../components/Header';

const mapStateToProps = state => {
  const isLogouting = selectors.selectIsLogouting(state);
  const currentUser = selectors.selectCurrentUser(state);
  const currentProject = selectors.selectCurrentProject(state);
  const currentBoard = selectors.selectCurrentBoard(state);
  const notifications = selectors.selectNotificationsForCurrentUser(state);
  const isCurrentUserManager = selectors.selectIsCurrentUserManagerForCurrentProject(state);
  const boards = currentProject ? selectors.selectBoardsForCurrentProject(state) : undefined;
  const filterUsers = currentBoard ? selectors.selectFilterUsersForCurrentBoard(state) : [];
  const filterLabels = currentBoard ? selectors.selectFilterLabelsForCurrentBoard(state) : [];
  const filterText = currentBoard ? selectors.selectFilterTextForCurrentBoard(state) : '';

  return {
    notifications,
    isLogouting,
    project: currentProject,
    user: currentUser,
    boards,
    currentBoardId: currentBoard ? currentBoard.id : undefined,
    filterUsers,
    filterLabels,
    filterText,
    canEditProject: isCurrentUserManager,
    canEditUsers: currentUser.isAdmin || currentUser.canManageUsers,
    isGlobalAdmin: currentUser.isAdmin,
    isOrganizationAdmin: currentUser.isOrganizationAdmin,
  };
};

const mapDispatchToProps = dispatch => {
  const actions = bindActionCreators(
    {
      onProjectSettingsClick: entryActions.openProjectSettingsModal,
      onUsersClick: entryActions.openUserManagementModal,
      onNotificationDelete: entryActions.deleteNotification,
      onUserSettingsClick: entryActions.openUserSettingsModal,
      onLogout: entryActions.logout,
      syncOrganizationFromClerk: entryActions.syncOrganizationFromClerk,
    },
    dispatch
  );

  return {
    ...actions,
    onSyncFromClerk: organizationId => actions.syncOrganizationFromClerk(organizationId),
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onSyncFromClerk: () => {
    const org = stateProps.user.organizationId;
    const orgId = typeof org === 'object' ? org.id : org;
    return dispatchProps.onSyncFromClerk(orgId);
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Header);
